<script>
import {mergeData} from 'vue-functional-data-merge'
import styles from './Choice.module.scss'
import {InlineError} from '../InlineError'

export default {
  name: 'Choice',
  props: {
    label: {
      type: String
    },
    helpText: {
      type: String
    },
    error: {
      type: String
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: null,
      default: undefined
    }
  },
  functional: true,
  render(h, {children, data, props, scopedSlots}) {
    const labelMarkup = h('label', mergeData(data, {
      class: [
        'UIElement',
        styles.Label_wrapper,
        props.disabled && styles.disabled,
        props.readonly && styles.readonly
      ]
    }), [
      h('span', {
        class: styles.Control
      }, children),
      h('span', {
        class: styles.Label
      }, props.label)
    ])

    const helpTextMarkup = props.helpText && h('div', {
      class: styles.HelpText
    }, props.helpText)

    const errorMarkup = props.error && h(InlineError, {
      class: styles.Error,
      props: {
        message: props.error
      }
    })

    // const descriptionMarkup = (helpTextMarkup || errorMarkup) &&
    //   h('div', {
    //     class: style.Descs
    //   }, [
    //     errorMarkup,
    //     helpTextMarkup
    //   ])

    // console.log('content', slots().content)
    // console.log('content2', scopedSlots.content())

    return h('div', mergeData(data, {
      class: [
        'UIElement',
        styles.Choice
      ]
    }), [
      labelMarkup,
      errorMarkup,
      helpTextMarkup,
      scopedSlots.content()
    ])
  }
}
</script>
